import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center overflow-hidden bg-neutral-900 pt-24" data-id="element-95">
      {/* Background image with stronger overlay */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <img src="https://cdn.magicpatterns.com/uploads/nRu31DFutjR6Q2vFZ7CaBN/image.png" alt="Taekwondo training background" className="w-full h-full object-cover" data-id="element-97" />
        {/* Stronger dark overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/70" data-id="element-98"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20" data-id="element-99">
        <div className="max-w-3xl" data-id="element-100">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-101">
            <span className="inline-block px-4 py-1.5 rounded-full bg-red-600/20 text-red-400 font-semibold text-sm tracking-wider uppercase mb-6 border border-red-600/20" data-id="element-102">
              HLD Taekwondo Sainte-Catherine
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" data-id="element-103">
              Taekwondo pour <br data-id="element-104" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-neutral-400" data-id="element-105">
                enfants, adolescents et adultes
              </span>
            </h1>
            <p className="text-lg md:text-xl text-neutral-300 mb-10 leading-relaxed max-w-2xl" data-id="element-106">
              Développez la confiance, la discipline, la forme physique et la
              concentration dans un environnement positif et structuré.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-107">
              <button onClick={() => {
              const element = document.querySelector('#contact');
              if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="px-8 py-4 bg-red-600 text-white font-bold rounded-full hover:bg-red-700 transition-all duration-300 shadow-lg shadow-red-600/20 flex items-center justify-center" data-id="element-108">
                Réserver un cours d'essai gratuit
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-109" />
              </button>
              <button onClick={() => {
              const element = document.querySelector('#programmes');
              if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-bold rounded-full hover:bg-white/20 transition-all duration-300 flex items-center justify-center" data-id="element-110">
                Voir nos programmes
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/50 flex flex-col items-center" data-id="element-111">
        <span className="text-xs uppercase tracking-widest mb-2" data-id="element-112">
          Découvrir
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" data-id="element-113"></div>
      </motion.div>
    </section>;
}